export const pivot = [
  {
    label: 'Owner Occupied Homes',
    value: 'owner_occupied_count',
  },
  {
    label: 'Average Job Size',
    value: 'average_job_size',
    unit: '$',
  },
  {
    label: 'Close Rate',
    value: 'close_rate',
    unit: '%',
  },
  {
    label: 'Cancellation Rate',
    value: 'cancellation_rate',
    unit: '%',
  },
  {
    label: 'Penetration Rate',
    value: 'penetration_rate',
    unit: '%',
  },
  {
    label: 'Retail vs Trade',
    value: 'retail_status',
  },
  {
    label: 'Tier A %',
    value: 'tier_1_percentage',
    unit: '%',
  },
  {
    label: 'Tier B %',
    value: 'tier_2_percentage',
    unit: '%',
  },
  {
    label: 'Tier C %',
    value: 'tier_3_percentage',
    unit: '%',
  },
  {
    label: 'Tier D %',
    value: 'tier_4_percentage',
    unit: '%',
  },
  {
    label: 'Opportunities',
    value: 'opps',
  },
  {
    label: 'Cumulative Tier (A,B,C) %',
    value: 'cumulative_1_2_3_percentage',
    unit: '%',
  },
];

export const links = [
  {
    url: '/dashboard',
    title: 'Dashboard',
  },
  {
    url: '/dashboard/map',
    title: 'Map View',
  },
];
